import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';
import { useFaqList } from '../hooks/useFaqList';

function isUkrainian(language: string | undefined) {
  return (language || '').toLowerCase().startsWith('ua');
}

const Faq = () => {
  const { t, i18n } = useTranslation();
  const { items, isLoading } = useFaqList();
  const useUa = isUkrainian(i18n.language);

  if (isLoading || items.length === 0) {
    return null;
  }

  return (
    <section className="faq-panel" id="faq">
      <div className="container-md container">
        <h2 className="title text-center size-24 pt-24 mb-24">{t('FAQ')}</h2>
        <Accordion defaultActiveKey="0">
          {items.map((item, index) => (
            <Accordion.Item key={item.id} eventKey={String(index)}>
              <Accordion.Header>
                {useUa ? item.titleUa : item.titleEn}
              </Accordion.Header>
              <Accordion.Body>
                <div
                  dangerouslySetInnerHTML={{
                    __html: useUa
                      ? item.descriptionUa ?? ''
                      : item.descriptionEn ?? '',
                  }}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
